import { useState, useRef, useEffect } from 'react'

const ClickableVideo = ({ src, className, ...props }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isHovered, setIsHovered] = useState(false)
  const previewVideoRef = useRef(null)
  const modalVideoRef = useRef(null)

  useEffect(() => {
    // Блокировка прокрутки когда модальное окно открыто
    if (isModalOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }

    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [isModalOpen])

  const handleVideoClick = (e) => {
    e.stopPropagation()
    setIsModalOpen(true)
  }

  const handleCloseModal = (e) => {
    e.stopPropagation()
    setIsModalOpen(false)
    if (modalVideoRef.current) {
      modalVideoRef.current.pause()
    }
  }

  const handleModalVideoClick = (e) => {
    e.stopPropagation()
  }

  return (
    <>
      {/* Превью видео */}
      <div 
        className="clickable-video-wrapper relative w-full h-full group cursor-pointer" 
        onClick={handleVideoClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <video
          ref={previewVideoRef}
          src={src}
          autoPlay
          loop
          muted
          playsInline
          className={className}
          {...props}
        />
        
        {/* Иконка воспроизведения */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <div className={`
            bg-black/60 backdrop-blur-sm rounded-full p-6 
            transition-all duration-300
            ${isHovered ? 'opacity-100 scale-100' : 'opacity-0 scale-75'}
          `}>
            <svg className="w-12 h-12 text-white" fill="currentColor" viewBox="0 0 24 24">
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
        </div>

        {/* Иконка звука в углу */}
        <div className="absolute bottom-4 right-4 z-10 pointer-events-none">
          <div className={`
            bg-black/60 backdrop-blur-sm rounded-full p-3 
            transition-all duration-300
            ${isHovered ? 'opacity-100 scale-100' : 'opacity-0 scale-75'}
          `}>
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" />
            </svg>
          </div>
        </div>


      </div>

      {/* Модальное окно с видео */}
      {isModalOpen && (
        <div 
          className="fixed inset-0 z-[9999] bg-black/95 flex items-center justify-center p-4 md:p-8 lg:p-12"
          onClick={handleCloseModal}
        >
          {/* Кнопка закрытия */}
          <button
            onClick={handleCloseModal}
            className="absolute top-6 right-6 z-[10000] bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-full p-3 transition-all duration-300 group"
            aria-label="Close"
          >
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          {/* Видео в модальном окне */}
          <div 
            className="relative w-full max-w-5xl max-h-[85vh]"
            onClick={handleModalVideoClick}
          >
            <video
              ref={modalVideoRef}
              src={src}
              autoPlay
              loop
              controls
              playsInline
              className="w-full h-full max-h-[85vh] object-contain rounded-2xl shadow-2xl"
            />
          </div>
        </div>
      )}
    </>
  )
}

export default ClickableVideo
